import { Request } from './request';
import { BillingParameter, partsFormType,offerTemporaryTemporary,appointmentParameter,storeDetailParameter,storeDetail,addStoreParameter } from "@/assets/types/common";
import { LocationQueryValue } from 'vue-router';

// 七牛云上传
const getQiNiuYunToken = () => {
  return Request.axiosInstance({
    url: 'adminapi/Upload/token',
    data:{}
  })
}
// 登录
const postLogin = (data:{account:string,password:string,type:number,url:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/Login/login',
    data
  })
}
// 注销登录
const postLogout = () => {
  return Request.axiosInstance({
    url: 'adminapi/Login/logout',
    data:{}
  })
}

// 权限列表
const privilegeList = (data:{type:number}) => {
  return Request.axiosInstance({
    url: 'adminapi/Privilege/list',
    data
  })
}
// 角色权限列表
const permissionList = (data:{type:number,role_name:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/Admin/permissionList',
    data
  })
}
// 基本设置--列表（类型 1 合作方 2 服务类型 3支付方式 4 收入类型 5支出类型 6 回访结果 7 自动回访建议 8 跟进类型 9 保险公司 10 返现方案）
const getBasicsetList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Basicset/list',
    data
  })
}

// 基本设置--列表（类型 1 合作方 2 服务类型 3支付方式 4 收入类型 5支出类型 6 回访结果 7 自动回访建议 8 跟进类型 9 保险公司 10 返现方案）
//不分页的
const getBasicsetTotalList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Basicset/totalList',
    data
  })
}

// 基本设置 获取除系统占用之外的类型
const getSpecialTotalList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Basicset/specialTotalList',
    data
  })
}

/*/
* 配件管理接口
/*/

// 配件表单列表
const getManagementTable = (data: { page: number, pagesize: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Mountings/list',
    data
  })
}
// 配件添加
const getManagementTableAdd = (data: partsFormType) => {
  return Request.axiosInstance({
    url: 'adminapi/Mountings/post',
    data
  })
}
// 配件编辑
const getManagementTableEdit = (data: partsFormType) => {
  return Request.axiosInstance({
    url: 'adminapi/Mountings/edit',
    data
  })
}
// 配件启、禁用
const getSetManagement = (data: { id: number, status: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Mountings/updStatus',
    data
  })
}

// 服务项目启、禁用
const getSetProject = (data: { id: number, status: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Project/updStatus',
    data
  })
}

// 品牌列表、单位列表、返现列表、大类列表与小类列表
const getSelectList = (data: { search?: string, type_pid?: number | null, data?: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/Mountings/item',
    data
  })
}
// 配件分类表单
const getMountingsTypeTable = (data: { page: number, pagesize: number, pid?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsType/list',
    data
  })
}
// 配件分类启、禁用
const postSetMountingsType = (data: { id: number, status: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsType/updStatus',
    data
  })
}
// 配件分类编辑
const postEditMountingsType = (data: { name: string, sort: number, id?: number, pid?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsType/edit',
    data
  })
}
// 配件分类新增
const postAddMountingsType = (data: { name: string, sort: number, pid?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsType/Post',
    data
  })
}
// 配件品牌表单
const getMountingsBrandTable = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsBrand/list',
    data
  })
}
// 配件品牌编辑
const postEditMountingsBrand = (data: { id: number, name: string, sort: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsBrand/edit',
    data
  })
}
// 配件品牌新增
const postAddMountingsBrand = (data: { sort: number, name: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsBrand/post',
    data
  })
}

// 统计每年每月利润
const profitForYear = (data: { }) => {
  return Request.axiosInstance({
    url: 'adminapi/BusinessSummary/profitForYear',
    data
  })
}

const profitForYearExport = (data: { }) => {
  return Request.axiosInstance({
    url: 'adminapi/BusinessSummary/profitForYearExport',
    data
  })
}

//统计每月日报
const profitDataMonthDay = (data: { }) => {
  return Request.axiosInstance({
    url: 'adminapi/BusinessSummary/profitDataMonthDay',
    data
  })
}

const profitDataMonthDayExport = (data: { }) => {
  return Request.axiosInstance({
    url: 'adminapi/BusinessSummary/profitDataMonthDayExport',
    data
  })
}

// 配件品牌删除
const postDeleteMountingsBrand = (data: { id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsBrand/mountingsBrandDel',
    data
  })
}

// 配件单位表单
const getMountingsUnitTable = (data: { page: number, pagesize: number, status?: number, name?: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsUnit/list',
    data
  })
}
// 配件单位编辑
const postEditMountingsUnit = (data: { id: number, name: string, sort: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsUnit/edit',
    data
  })
}
// 配件单位新增
const postAddMountingsUnit = (data: { sort: number, name: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsUnit/post',
    data
  })
}
// 配件单位删除
const postDeleteMountingsUnit = (data: { id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/MountingsUnit/del',
    data
  })
}

/*/
*订单管理接口
/*/

// 服务订单表单
const getOrderTable = (data: { page: number, pagesize: number, status?: number, search?: string, project_type_pid?: number, project_id?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/order/list',
    data
  })
}
// 服务订单核销
const postOrderWriteOff = (data: { nucleus_pin_code: string, order_id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/order/writeOff',
    data
  })
}

// 服务分类列表
const orderServiceList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/order/orderServiceList',
    data
  })
}

// 获取所有的检车项目
const carCheckProjectList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Carcheck/carCheckProjectArray',
    data
  })
}

// 新增检车分组
const addCheckProjectGroup = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Carcheck/addCheckGroup',
    data
  })
}
// 编辑检车分组
const editCheckProjectGroup = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Carcheck/editCheckGroup',
    data
  })
}
// 获取某个分组的检车项目
const getCarCheckArray = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Carcheck/getCarCheckArray',
    data
  })
}
// 启用禁用分组
const carCheckchangeStatus = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Carcheck/changeStatus',
    data
  })
}

// 获取检车分组
const getCheckProjectGroup = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Carcheck/groupList',
    data
  })
}

/*/
* 前台收银接口
/*/
// 接车开单列表
const getOrderCarTabble = (data: BillingParameter) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/list',
    data
  })
}
// 服务类型、合作方、保险公司列表
const getOrderCarSelectList = () => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/get',
    data: {}
  })
}
// 配件销售--新增
const getPartsSaleAdd = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/create',
    data
  })
}

// 配件销售--编辑
const getPartsSaleEdit = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/edit',
    data
  })
}

// 配件销售--作废，恢复，审核，反审核
const getPartsSaleUpState = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/upState',
    data
  })
}

// 配件销售--详情
const getPartsSaleInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/info',
    data
  })
}

// 配件销售--结算详情
const getPartsSaleSettlementInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/settlementInfo',
    data
  })
}

// 配件销售--坏账
const getPartsSaleBadDebt = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/badDebt',
    data
  })
}

// 配件销售--结算与回款
const getPartsSaleSettlement = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartsSale/settlement',
    data
  })
}

// 收款方式
const getCollectionType = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/order/collection',
    data
  })
}

// 工单结算导出
const workSettlementExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Order/workSettlementExport',
    data
  })
}

// 前台收银导出
const orderCarExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/listEXport',
    data
  })
}

// B单列表
const workSettlementFade = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/workSettlementFade',
    data
  })
}

// 新建B单
const createFadeOrder = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/createFadeOrder',
    data
  })
}

// 购卡订单导出
const cardOrderExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Order/CardOrderExport',
    data
  })
}

// 尊享卡导出
const memberCardListExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/User/memberCardListExport',
    data
  })
}

// 车辆信息
const getCarInfoDetail = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Car/info',
    data
  })
}
// 车辆信息修改
const editCarInfoDetail = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Car/editCarInfo',
    data
  })
}

// 查看尊享卡使用记录
const getCardUseLogDetail = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/VipCardLog/cardUseLogDetail',
    data
  })
}

// 查看用户消费记录
const getRecordDetail = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BalanceLog/recordDetail',
    data
  })
}

// 所属单位
const getOrderCarRepairunit = (data: { search?: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/repairunit',
    data
  })
}
// 品牌车型
const getCarBrand = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/carBrand',
    data
  })
}
// 查询支付是否成功
const queryPayLog = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Payment/lookPayLogList',
    data
  })
}
// 施工部门、员工
const getConstructors = (data: { type?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/constructors',
    data
  })
}
// 接车订单详情
const getOrderCarInfo = (data: { order_id: string | null | number | LocationQueryValue[] }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/info',
    data
  })
}
// 获取订单支付二维码
const getPayQrcode = (data: { order_id: string | null | number | LocationQueryValue[] }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/getPayQrcode',
    data
  })
}

// 接车详情
const getReceivingCar = (data: { order_id: string | null | LocationQueryValue[] }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/getreceivingcar',
    data
  })
}
// 施工人员信息
const getConstructionslist = (data: {id:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/MobileOrder/constructionslist',
    data
  })
}

// 运营设置--工单必填
const workRequiredList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Operate/workRequiredList',
    data
  })
}

// 修改接车详情
const postEditReceivingCar = (data: any) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/editreceivingcar',
    data
  })
}

// 获取修改接车详情表单必填项
const getSetitembasicset = (data: { basicset_id: number, scene: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/SetitemBasicset/getsetitembasicset',
    data
  })
}
// 报价列表
const getInfoOrderOffer = (data: { order_id: number, is_buy?:boolean }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/info_order_offer',
    data
  })
}
// 报价列表的历史报价
const getInfoOrderOfferHistory = (data: { order_offer_id: number, type?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/info_order_offer_history',
    data
  })
}

// 删除报价列表
const postDelOrderOffer = (data: { order_offer_id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/delOrderOffer',
    data
  })
}
// 获取报价信息维修项目列表
const getOrderCarProject = (data: { project_type_pid?: number, search?: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/project',
    data
  })
}
// 获取用户已购服务
const getUserProject = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/getUserPackage',
    data
  })
}
// 获取用户已购vip
const getUserVipCards = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/getUserVipCard',
    data
  })
}
// 订单更换车辆
const changeCarForOrder = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/changeCarForOrder',
    data
  })
}
// 订单更换用户id
const changeUserForOrder = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/changeUserForOrder',
    data
  })
}
// 订单更换用户id并绑定
const bindUserForOrder = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/bindUserForOrder',
    data
  })
}
// 报价信息添加项目、配件
const postAddOrderOffer = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/addOrderOffer',
    data
  })
}
// 报价信息添加项目、配件V2
const postAddOrderOfferV2 = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/addOrderOfferV2',
    data
  })
}
// 报价信息添加项目、配件 尊享卡专用
const postAddOrderOfferVip = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/addOfferForVip',
    data
  })
}
// 添加临时项目、配件
const postAddOrderOfferTemporary = (data: offerTemporaryTemporary) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/addOrderOfferTemporary',
    data
  })
}
// 获取报价信息配件列表
const getOrderCarMountings = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/mountings',
    data
  })
}
// 查询某个维修车辆出库配件的信息
const getCheckOutMountingsInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/getCheckOutMountingsInfo',
    data
  })
}
// 查询某个辅料领料出库配件的信息
const getMaterialInfo = (data: {}) => {
    return Request.axiosInstance({
        url: 'adminapi/OrderCar/getMaterialInfo',
        data
    })
}
// 查询送修单位
const getRepairUnitList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/RepairUnit/list',
    data
  })
}
// 查询所有送修单位
const getAllRepairUnitList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/RepairUnit/allList',
    data
  })
}
// 查询合作方
const getPartnerList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartnerList/list',
    data
  })
}

// 查询所有合作方
const getAllPartnerList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PartnerList/allList',
    data
  })
}
// 查询仓位
const getPositionManageList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/PositionManage/list',
    data
  })
}

// 编辑报价
const postEditOrderOffer = (data: { quoted_price?: number, builders_type?: number, builders_id?: string | number, setyj?: number, yjbl?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/editOrderOffer',
    data
  })
}

// 获取VIN信息
const getVinInfo = (data: { vin: string}) => {
  return Request.axiosInstance({
    url: 'adminapi/Ocr/getVinInfo',
    data
  })
}

//车辆信息
const getCarOne = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/CustomerService/getCarOne',
    data
  })
}

//报价那里修改名字
const changeOfferName = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/editTempOfferName',
    data
  })
}

//车辆管理导出
const carManageExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/CustomerService/carManageExport',
    data
  })
}

//新增车辆
const addCarInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Car/addCarInfo',
    data
  })
}

//待办列表
const scheduleIndex = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Schedule/index',
    data
  })
}

//待办未处理的总数
const scheduleDataConfig = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Schedule/dataConfig',
    data
  })
}

//待办类型
const scheduleTypeListAPi = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Schedule/getTypeList',
    data
  })
}

//到期提醒导出
const carDueExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/CustomerService/carDueExport',
    data
  })
}

//车辆产值排行导出
const carRankExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/CustomerService/carRankExport',
    data
  })
}

// 绑定会员
const postBindingUser = (data: { order_id: number, user_id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/bindinguser',
    data
  })
}
// 取消绑定会员
const postUnBindUser = (data: { order_id: number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/userIsStatus',
    data
  })
}

// 工单详情
const getOrderCarOrderinfo = (data: { order_id: number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/orderinfo',
    data
  })
}

// B单详情
const getFadeOrderDetail = (data: { order_id: number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/fadeOrderDetail',
    data
  })
}

// B单接车详情
const getFadeReceivingCar = (data: { order_id: string | null | LocationQueryValue[] }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/getreceivingcar',
    data
  })
}

// B单新增一个收入
const getIncomePrice = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/changeIncomePrice',
    data
  })
}

// B单修改信息
const changeFadeOrder = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/changeCarInfo',
    data
  })
}

// B单修改接车详情
const postFadeEditReceivingCar = (data: any) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/editreceivingcar',
    data
  })
}

// B单报价列表
const getFadeInfoOrderOffer = (data: { order_id: number, is_buy?:boolean }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/info_order_offer',
    data
  })
}

// B单删除报价列表
const postFadeDelOrderOffer = (data: { order_offer_id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/delOrderOffer',
    data
  })
}

// B单报价信息添加项目、配件V2
const postFadeAddOrderOfferV2 = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/addOrderOfferV2',
    data
  })
}

// B单添加临时项目、配件
const postFadeAddOrderOfferTemporary = (data: offerTemporaryTemporary) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/addOrderOfferTemporary',
    data
  })
}

// B单接车订单详情
const getFadeOrderCarInfo = (data: { order_id: string | null | number | LocationQueryValue[] }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/info',
    data
  })
}

// B单编辑报价
const postFadeEditOrderOffer = (data: { quoted_price?: number, builders_type?: number, builders_id?: string | number, setyj?: number, yjbl?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderFade/editOrderOffer',
    data
  })
}

//工单详情-预收款新增
const orderAdvancePayment = (data:{})=>{
  return Request.axiosInstance({
    url: 'adminapi/OrderAdvancePayment/add',
    data
  })
}
//尊享卡适用门店
const getBranchStoreList = (data:{})=>{
  return Request.axiosInstance({
    url: 'adminapi/Admin/getBranchStoreList',
    data
  })
}

//工单详情-预收款列表
const orderAdvancePaymentList = (data:{})=>{
  return Request.axiosInstance({
    url: 'adminapi/OrderAdvancePayment/list',
    data
  })
}

// 工单详情
const getWorkSettlementInfo = (data: {order_id: number}) => {
  return Request.axiosInstance({
    url: 'adminapi/order/workSettlementInfo',
    data
  })
}

// 其他成本列表
const getOthercostsList = (data: { order_id: number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/othercostslist',
    data
  })
}
// 添加其他成本
const postAddothercosts = (data: { order_id: number,othercosts_costprice:string,branch_id:null|number,supplier_id:null|number,admin_id:null|number,cpayment:number,othercosts_name:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/addothercosts',
    data
  })
}

// 删除其他成本
const postDelothercosts = (data: { othercosts_id: number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/delothercosts',
    data
  })
}
// 订单审核、反审核、作废
const postSetorderstatus = (data: { order_id: number,orderstatus:number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/updorderstatus',
    data
  })
}
// 订单质检审核/质检反审核
const postSetQualityTesting = (data: { order_id: number,qualitytesting_status:number}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/qualitytesting',
    data
  })
}



/*/
*预约管理
/*/
//管理列表
const getAppointmentTable = (data: appointmentParameter) => {
  return Request.axiosInstance({
    url: 'adminapi/Preabout/list',
    data
  })
}
//更改状态
const appointmentAudit = (data: { status: number, id: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Preabout/audit',
    data
  })

}

/*/
*业务报表
/*/

//项目销售明细-导出
const getProjectSellExport = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/BusinessReport/projectSellexport',
    data
  })
}

// 配件销售明细导出
const mountingsSellExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BusinessReport/mountingsSellExport',
    data
  })
}

// 配件施工明细导出
const partsConstructionExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/ConstructionOrder/partsConstructionExport',
    data
  })
}

// 项目施工明细导出
const projectConstructionExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/ConstructionOrder/projectConstructionExport',
    data
  })
}

// 部门利润汇总导出
const totalExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/totalExport',
    data
  })
}

// 部门利润汇总-配件销售利润列表
const getPartsSaleProfit = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getPartsSaleProfit',
    data
  })
}

// 部门利润汇总-产值列表
const getOutputValueList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getOutputValueList',
    data
  })
}

// 部门利润汇总-赠送成本列表
const getGiveCostList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getGiveCostList',
    data
  })
}

// 部门利润汇总-其他成本列表
const getOtherCostsList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getOtherCostsList',
    data
  })
}

// 部门利润汇总-坏账列表
const getBaddebtList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getBaddebtList',
    data
  })
}

// 部门利润汇总-辅料成本列表
const getWhRecordList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getWhRecordList',
    data
  })
}

// 部门利润汇总-固定资产折旧
const getFixedList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/getFixedList',
    data
  })
}

// 营业汇总导出
const businessListExport = (data: {}) => {
    return Request.axiosInstance({
        url: 'adminapi/BusinessSummary/businessListExport',
        data
    })
}

/*/
*采购管理
/*/

//采购列表
const getPurchaseTable = (data: { page: number, pagesize: number, time_type?: string, start_time?: string, end_time?: string, purchase_type: string, status?: number | string, supplier_id?: number | string, employee_id: number | string, search: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/list',
    data
  })
}

//采购明细
const getPurchaseDetail = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/detailedList',
    data
  })
}

//采购信息修改
const purchaseInfoUpdate = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/purchaseInfoUpdate',
    data
  })
}

//待采购
const getWaitPurchaseList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/getOrderOfferPartsList',
    data
  })
}

//采购管理--作废
const purchaseToVoid = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/tovoid',
    data
  })
}

//采购管理--获取最近采购单价
const getRecentlyPrice = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/getRecentlyPrice',
    data
  })
}

//采购管理--执行修改
const purchaseEdit = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/edit',
    data
  })
}

//采购管理--退货
const purchaseReturnGoods = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/returngoods',
    data
  })
}

//采购管理--退货修改
const returnGoodsEdit = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/returnGoodsEdit',
    data
  })
}

//采购管理--恢复
const purchaseRecovery = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/recovery',
    data
  })
}

//采购明细-导出
const getPurchaseExport = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/export',
    data
  })
}

//采购应付导出
const purchaseCopeExport = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/purchaseCopeExport',
    data
  })
}

//采购应付-添加到批量付款列表
const addBatchPayListPost = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/addBatchPayList',
    data
  })
}

//采购应付-移除批量付款列表
const removeBatchPayListPost = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/removeBatchPayList',
    data
  })
}

//采购应付-执行批量付款
const purchasePayTotal = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/purchasePayTotal',
    data
  })
}


//工单应收-添加到批量回款列表
const addBatchPayBackList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/addBatchPayBackList',
    data
  })
}

//工单应收-移除批量回款列表
const removeBatchPayBackList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/removeBatchPayBackList',
    data
  })
}

//工单应收-批量回款结算
const orderBatchBackList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/orderBatchBackList',
    data
  })
}

//收入记账导出
const incomeListExport = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/incomeExport',
    data
  })
}

//查询某天某种支付方式的收入
const incomeListByDay = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/incomeListByDay',
    data
  })
}

//后台修改用户余额
const changeUserStoreMoney = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/User/changeUserStoreMoney',
    data
  })
}

//收入记账--列表
const gteIncomeList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/BranchSummary/incomeList',
    data
  })
}

//收入记账--详情
const gteIncomeDetail = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/incomeDetail',
    data
  })
}

//支出记账--列表
const gteExpenditureList = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/expenditureList',
    data
  })
}

//支出记账--详情
const getExpenditureDetail = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/expenditureDetail',
    data
  })
}

//支出记账导出
const expenditureExport = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/expenditureExport',
    data
  })
}

//采购应付--收付款详情
const purchaseCopeInfo = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/purchaseCopeInfo',
    data
  })
}

// 采购详情
const getPurchaseInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/info',
    data
  })
}

// 采购生成
const creatPurchaseOrder = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/create',
    data
  })
}

//获取供应商列表
const getSupplierList = (data: { page?: number, pagesize?: number, status?: number, search?: number }) => {
  return Request.axiosInstance({
    url: "adminapi/supplier/list",
    data
  })

}
//获取所有供应商列表
const getSupplierTotalList = (data: { page?: number, pagesize?: number, status?: number, search?: number }) => {
  return Request.axiosInstance({
    url: "adminapi/supplier/totalList",
    data
  })

}
//获取供应商列表
const getAdminList = (data: { search?: string }) => {
  return Request.axiosInstance({
    url: "adminapi/Purchase/adminlist",
    data
  })

}
// 审核和反审核
const toExamine = (data: { purchase_id: string | number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Purchase/toexamine',
    data
  })
}

/*/
*仓库管理
/*/

// 出入库详情
const getLibraryInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/libraryInfo',
    data
  })
}
// 出库选择车牌后查询配件出库数据
const getMountingsCheckOutInfo = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/OrderCar/mountingsCheckOut',
    data
  })
}

// 仓库管理--领料明细(导出)
const pickingInfoExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/pickingInfoExport',
    data
  })
}

// 仓库管理--配件库存 (导出)
const partsStockExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/partsStockExport',
    data
  })
}

// 仓库管理--出库单(修改)
const changeDelivery = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/ChangeDelivery',
    data
  })
}

// 仓库管理--采购退货出库单(修改)
const editReturnGoodsWarehouse = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/editReturnGoods',
    data
  })
}

// 仓库管理--进销存导出
const enterPinExport = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/enterPinExport',
    data
  })
}

// 配件库存---开启预警、取消预警
const updateWarning = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Warehouse/updateWarning',
    data
  })
}

/*/
*门店管理
/*/

//门店列表
const getframeworkList = (data: { page?: number, pagesize?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Framework/list',
    data

  })
}

//门店列表
const getStoreTotalList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Framework/totalList',
    data

  })
}

//下载收款码
const downloadCode = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Framework/downloadCode',
    data

  })
}

// 角色列表
const getframeworkRoleList = (data: { admin_id: number, page?: number, pagesize?: number }) => {
  return Request.axiosInstance({
    url: 'adminapi/Role/list',
    data
  })

}
// 门店详情
const getStoreInfo = (data: { id: string | null | LocationQueryValue[] }) => {
  return Request.axiosInstance({
    url: 'adminapi/Framework/editInfo',
    data
  })
}
// 编辑门店
const getEditStore = (data: { id: string | null | LocationQueryValue[] }&storeDetail&storeDetailParameter) => {
  return Request.axiosInstance({
    url: 'adminapi/Framework/edit',
    data
  })
}
// 新增门店
const postAddStore = (data: addStoreParameter) => {
  return Request.axiosInstance({
    url: 'adminapi/Framework/create',
    data
  })
}

/*/
*项目管理
/*/
// 获取返现方案、项目分类、卡分类
const getProjectAcquire = (data: { data: string }) => {
  return Request.axiosInstance({
    url: 'adminapi/Project/acquire',
    data
  })
}
/*/
*个人中心
/*/
// 个人信息
const getPersonalInfo = () => {
  return Request.axiosInstance({
    url: 'adminapi/Admin/personalInfo',
    data:{}
  })
}
// 修改密码
const postEditPassword = (data:{primary_password:string,new_password:string,confirm_password:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/Admin/upPassword',
    data
  })
}
// 公司信息
const getCompanyInfo = () => {
  return Request.axiosInstance({
    url: 'adminapi/Admin/companyInfo',
    data:{}
  })
}

/*/
*  运营管理
/*/
// 优惠卷管理
const getCouponList = (data:{page?: string, limit?: string, status: string | number, search?: string}) => {
	return Request.axiosInstance({
		url: 'adminapi/Coupon/list',
		data
	})
}

// 服务分类列表
const getProjectTypeList = (data:{page?: string, limit?: string}) => {
	return Request.axiosInstance({
		url: 'adminapi/ProjectType/list',
		data
	})
}
// 尊享卡分类列表
const getVipClassList = (data:{token?: string}) => {
	return Request.axiosInstance({
		url: 'adminapi/VipClass/list',
		data
	})
}
// 获取门店所有尊享卡列表
const getStoreVipCardList = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/VipCard/storeList',
    data
  })
}
// 获取门店所有尊享卡项目列表
const getStoreVipClassList = (data: {vip_card_id:number}) => {
  return Request.axiosInstance({
    url: 'adminapi/VipClass/storeList',
    data
  })
}
// 发放尊享卡
const giveOutVipCard = (data: {phone:number,vip_card_id:number,start_time:number,end_time:number,vip_class_ids:string,surplus_numbers:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/VipCard/giveOut',
    data
  })
}
// 发放项目
const giveOutProject = (data: {}) => {
  return Request.axiosInstance({
    url: 'adminapi/Project/giveOut',
    data
  })
}
// 编辑用户尊享卡
const editUserVipCard = (data: {phone:number,vip_card_id:number,start_time:number,end_time:number,vip_class_ids:string,surplus_numbers:string}) => {
  return Request.axiosInstance({
    url: 'adminapi/VipCard/editUserVipCard',
    data
  })
}

// 删除用户尊享卡
const deleteUserVipCard = (data: {id:number}) => {
  return Request.axiosInstance({
    url: 'adminapi/VipCard/deleteUserVipCard',
    data
  })
}

// 返现方案列表
const getLevelBackList = (data:{token?: string}) => {
	return Request.axiosInstance({
		url: 'adminapi/UserLevel/levelBack',
		data
	})
}

/*    财务管理   */
// 工单应收导出
const workListExport = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/Bookkeeping/workExport',
    data
  })
}

/*    客户回访   */
//查询回访详情
const getBackVisitInfo = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/BackVisit/getBackVisitInfo',
    data
  })
}

//回访登记
const createBackVisit = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/BackVisit/createBackVisit',
    data
  })
}

//编辑回访详情
const editBackVisit = (data:{}) => {
  return Request.axiosInstance({
    url: 'adminapi/BackVisit/editBackVisit',
    data
  })
}

export {
  //
  getBackVisitInfo,
  createBackVisit,
  editBackVisit,
    //
  getQiNiuYunToken,
  postLogin,
  postLogout,
  privilegeList,
  permissionList,
  getBasicsetList,
  // 配件管理
  getManagementTable,
  getManagementTableAdd,
  getManagementTableEdit,
  getSetManagement,
  getSetProject,
  getSelectList,
  getMountingsTypeTable,
  postSetMountingsType,
  postEditMountingsType,
  postAddMountingsType,
  getMountingsBrandTable,
  postEditMountingsBrand,
  postAddMountingsBrand,
  postDeleteMountingsBrand,
  getMountingsUnitTable,
  postEditMountingsUnit,
  postAddMountingsUnit,
  postDeleteMountingsUnit,
  // 订单管理
  getOrderTable,
  postOrderWriteOff,
  orderServiceList,
    //业务报表
  getProjectSellExport,
  mountingsSellExport,
  projectConstructionExport,
  totalExport,
  partsConstructionExport,
  // 前台收银
  getPartsSaleAdd,
  getPartsSaleInfo,
  getConstructionslist,
  getOrderCarTabble,
  getOrderCarSelectList,
  getOrderCarRepairunit,
  getCarBrand,
  getConstructors,
  getOrderCarInfo,
  getPayQrcode,
  getReceivingCar,
  postEditReceivingCar,
  getSetitembasicset,
  getInfoOrderOffer,
  getInfoOrderOfferHistory,
  postDelOrderOffer,
  getOrderCarProject,
  postAddOrderOffer,
  postAddOrderOfferV2,
  postAddOrderOfferTemporary,
  getOrderCarMountings,
  postEditOrderOffer,
  getVinInfo,
  postBindingUser,
  postUnBindUser,
  getOrderCarOrderinfo,
  getOthercostsList,
  postAddothercosts,
  postDelothercosts,
  postSetorderstatus,
  postSetQualityTesting,
  getWorkSettlementInfo,
  workSettlementExport,
  getUserProject,
  getUserVipCards,
  getStoreVipCardList,
  getStoreVipClassList,
  giveOutVipCard,
  editUserVipCard,
  deleteUserVipCard,
  postAddOrderOfferVip,
  // 项目管理
  getProjectAcquire,
  //预约管理
  getAppointmentTable,
  appointmentAudit,

  //采购管理
  getPurchaseTable,
  getPurchaseInfo,
  getSupplierList,
  getSupplierTotalList,
  getAdminList,
  toExamine,
  getPurchaseDetail,
  purchaseInfoUpdate,
  getWaitPurchaseList,
  getPurchaseExport,
  purchaseCopeExport,
  purchaseCopeInfo,
  purchaseToVoid,
  purchaseRecovery,
  purchaseEdit,
  creatPurchaseOrder,
  purchaseReturnGoods,
  returnGoodsEdit,
  getRecentlyPrice,
  //门店管理
  getframeworkList,
  getframeworkRoleList,
  getStoreInfo,
  getEditStore,
  postAddStore,
  downloadCode,
  getCarInfoDetail,
  editCarInfoDetail,

  // 个人中心
  getPersonalInfo,
  postEditPassword,
  getCompanyInfo,
  /* 运营管理*/
  //优惠卷管理
  getCouponList,
  // 服务分类列表
  getProjectTypeList,
  // 尊享卡分类列表
  getVipClassList,
  // 返现方案列表
  getLevelBackList,
    /*仓库管理*/
    //出入库详情
  getLibraryInfo,
  getCarOne,
  orderAdvancePayment,
  orderAdvancePaymentList,
  pickingInfoExport,
  partsStockExport,
  enterPinExport,
  changeDelivery,
  editReturnGoodsWarehouse,
  getMountingsCheckOutInfo,
  getPositionManageList,
    //配件库存
  updateWarning,
  /*财务管理*/
  workListExport,
  cardOrderExport,
  incomeListExport,
  expenditureExport,
    /*客户服务*/
  carManageExport,
  addCarInfo,
  carDueExport,
  carRankExport,
    /*基本设置*/
  carCheckProjectList,
  addCheckProjectGroup,
  editCheckProjectGroup,
  getCheckProjectGroup,
  getCarCheckArray,
  carCheckchangeStatus,
  giveOutProject,
  getBranchStoreList,
  getCheckOutMountingsInfo,
    getMaterialInfo,
  getRepairUnitList,
getPartnerList,
  getAllPartnerList,
  getAllRepairUnitList,
  changeCarForOrder,
  changeUserForOrder,
  getCardUseLogDetail,
  getRecordDetail,
  incomeListByDay,
  getPartsSaleEdit,
  getPartsSaleUpState,
  getCollectionType,
  getPartsSaleSettlementInfo,
  getPartsSaleSettlement,
  getPartsSaleBadDebt,
  getPartsSaleProfit,
  gteIncomeList,
  gteExpenditureList,
  getOutputValueList,
  getWhRecordList,
  getFixedList,
  getBasicsetTotalList,
  getSpecialTotalList,
  getStoreTotalList,
  changeUserStoreMoney,
  workRequiredList,
  gteIncomeDetail,
  getExpenditureDetail,
  memberCardListExport,
  addBatchPayListPost,
  removeBatchPayListPost,
  purchasePayTotal,
  workSettlementFade,
  createFadeOrder,
  getFadeOrderDetail,
  getFadeOrderCarInfo,
  getFadeReceivingCar,
  postFadeEditReceivingCar,
  postFadeDelOrderOffer,
  postFadeAddOrderOfferV2,
  postFadeAddOrderOfferTemporary,
  getFadeInfoOrderOffer,
  postFadeEditOrderOffer,
  addBatchPayBackList,
  removeBatchPayBackList,
  orderBatchBackList,
  changeOfferName,
  getGiveCostList,
  getIncomePrice,
  businessListExport,
  getOtherCostsList,
  getBaddebtList,
  bindUserForOrder,
  changeFadeOrder,
  orderCarExport,
  profitForYear,
  profitForYearExport,
  profitDataMonthDay,
  profitDataMonthDayExport,
  queryPayLog,
    //待办列表
  scheduleIndex,
  scheduleDataConfig,
  scheduleTypeListAPi
}
